// @ts-check

// checkout flow context for sim
export default () => {
  console.warn('No flow is chosen');
}
